import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { AuthLayout } from '../components/layouts/AuthLayout';
import { LoginForm } from '../components/molecules/LoginForm';

interface LoginFormData {
  email: string;
  password: string;
  name: string;
}

export const LoginPage: React.FC = () => {
  const [isSignup, setIsSignup] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string>('');
  const { login, signup } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (formData: LoginFormData) => {
    setLoading(true);
    setError('');

    try {
      if (isSignup) {
        await signup(formData.email, formData.password, formData.name);
      } else {
        await login(formData.email, formData.password);
      }
      navigate('/dashboard');
    } catch (err) {
      setError((err as Error).message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout>
      {error && (
        <div
          className="mb-4 p-3 bg-red-100 border border-red-300 text-red-700 rounded-lg text-sm"
          data-testid="error-message"
        >
          {error}
        </div>
      )}
      <LoginForm
        onSubmit={handleSubmit}
        onToggleMode={() => setIsSignup(!isSignup)}
        isSignup={isSignup}
        disabled={loading}
      />
      {!isSignup && (
        <div className="mt-4 text-center">
          <p className="text-sm text-gray-600 dark:text-gray-400">
            Demo credentials: demo@trader.com / password123
          </p>
        </div>
      )}
    </AuthLayout>
  );
};